
import { createSelector } from "reselect"


const selectUser = (state) => state.user;

export const userSelector = createSelector(
    [selectUser],
    (data) => ({
        users: data?.users?.users,
        total: data?.users?.pagination?.totalUsers,
        page: data?.users?.pagination?.currentPage,
        limit: data?.users?.pagination?.limit,
        totalPages: data?.users?.pagination?.totalPages
    })
)